import type { JSX } from "react";

import { Group } from "@mantine/core";

import type { GuideActionOption } from "../logic-builder";

import { GuideActionButton } from "./GuideActionButton";
import classes from "./GuideActionGroup.module.css";

interface GuideActionGroupProps {
    isLoading: boolean;
    onClick: (option: GuideActionOption) => void;
    options?: GuideActionOption[];
    currentStep: string;
}

export function GuideActionGroup({ currentStep, isLoading, onClick, options }: GuideActionGroupProps): JSX.Element {
    return (
        <Group gap="sm" justify="flex-end" pt="xs">
            {options?.toReversed().map((option) => {
                return (
                    <GuideActionButton
                        className={classes.guideActionButton}
                        key={`guide-action-button-${option.value}`}
                        currentStep={currentStep}
                        onClick={onClick}
                        isLoadingStep={isLoading}
                        option={option}
                    />
                );
            })}
        </Group>
    );
}
